import { BlockingLoader } from 'components/BlockingLoader/BlockingLoader';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { ErrorBoundaryAppFallback } from 'components/ErrorBoundaryAppFallback';
import { RootNavigation } from 'components/Navigation/RootNavigation';
import { SafeAreaSetter } from 'components/SafeAreaSetter';
import * as React from 'react';
import { Platform, StatusBar } from 'react-native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { AuthModal } from 'screens/AuthDialog/AuthDialog';
import { DialogAlert } from 'screens/DialogAlert';
import { DialogConfirm } from 'screens/DialogConfirm';
import { DialogSignature } from 'screens/DialogSignature';
import { DialogToast } from 'screens/DialogToast';
import { ImageModal } from 'screens/ImageModal';
import { persistor, store } from 'store';
import { KeyboardProvider } from 'react-native-keyboard-controller';

if (Platform.OS === 'web') {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

if (Platform.OS === 'android') {
  StatusBar.setTranslucent(true);
}

export const Loaded: React.FC<{ onReady: () => void }> = ({ onReady }) => (
  <GestureHandlerRootView style={{ flex: 1 }}>
    <ReduxProvider store={store}>
      {Platform.OS === 'ios' && <BlockingLoader />}
      <PersistGate loading={null} persistor={persistor}>
        <SafeAreaProvider>
          <KeyboardProvider>
            <ErrorBoundary FallbackComponent={ErrorBoundaryAppFallback}>
              <RootNavigation onReady={onReady} />
            </ErrorBoundary>
            <AuthModal />
            <DialogAlert />
            <DialogConfirm />
            <DialogSignature />
            <ImageModal />
            <SafeAreaSetter />
            <DialogToast />
          </KeyboardProvider>
        </SafeAreaProvider>
      </PersistGate>
      {Platform.OS !== 'ios' && <BlockingLoader />}
    </ReduxProvider>
  </GestureHandlerRootView>
);
